module.exports = __webpack_public_path__ + "bbfa6a2c732e789af553c4c48c84d664.png";